
import './style.css';

const Footer = () => {



    return(

        <footer className="  bg-dark">
            <h2>Padaria e Mercearia Mix</h2>
        </footer>
    )
}
export default Footer;